import * as React from 'react';

export default () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 69.014085 69.014085"
    fill="none"
    version="1.1"
    id="svg416"
    xmlns="http://www.w3.org/2000/svg">
    <defs id="defs420" />
    <rect
      width="70"
      height="70"
      rx="35"
      fill="#00b300"
      id="rect2"
      x="0"
      y="0"
    />
    <path
      d="m 34.382022,34.791331 q 2.140962,0 3.665585,-1.524623 1.524625,-1.524623 1.524625,-3.665585 0,-2.140961 -1.524625,-3.665585 -1.524623,-1.524623 -3.665585,-1.524623 -2.140961,0 -3.665585,1.524623 -1.524623,1.524624 -1.524623,3.665585 0,2.140962 1.524623,3.665585 1.524624,1.524623 3.665585,1.524623 z m 0,19.074018 q 7.915069,-7.266293 11.742849,-13.202593 3.827779,-5.936302 3.827779,-10.542611 0,-7.07166 -4.508994,-11.580654 -4.508994,-4.508994 -11.061634,-4.508994 -6.552638,0 -11.061631,4.508994 -4.508995,4.508994 -4.508995,11.580654 0,4.606309 3.827779,10.542611 3.82778,5.9363 11.742847,13.202593 z m 0,6.877026 Q 23.936727,51.854142 18.778958,44.231023 q -5.15777,-7.623118 -5.15777,-14.110878 0,-9.731642 6.260689,-15.505749 6.26069,-5.7741073 14.500145,-5.7741073 8.239458,0 14.500147,5.7741073 6.260689,5.774107 6.260689,15.505749 0,6.48776 -5.157769,14.110878 -5.15777,7.623119 -15.603067,16.511352 z m 0,-31.141252 z"
      id="path377"
      stroke-width="0.0648776"
      fill="#ffffff"
    />
  </svg>
);
